@if (errorMessage) {
    <div role="alert"
         class="alert alert-danger">{{ errorMessage }}</div>
}
<div *adaptLoading="isLoading">
    <div>
        @switch (cardDetails) {
            @case (undefined) {
                <div class="alert alert-warning">
                    <p>Your organisation is paying by credit card, however, no credit card information has been provided.</p>
                </div>
            }
            @default {
                <div>
                    <dd>
                        <div>
                            {{ cardDetails!.brand }} ending in
                            {{ cardDetails!.last4 }}
                        </div>
                        @if (cardDetails!.name) {
                            <div>{{ cardDetails!.name }}</div>
                        }
                        <div>Expiring {{ cardDetails!.expiryMonth }}/{{ cardDetails!.expiryYear }}</div>
                    </dd>
                </div>
            }
        }
    </div>
    @if (allowEditing && !isEditMode) {
        <button adaptButton="primary"
                class="mt-4"
                [adaptBlockingClick]="showUpdateCreditCardDialog">Update payment method</button>
    }
</div>
